import Api from './Api';

export default class CategoriasApi {

    all = async () => {
        return await Api.get('categorias').then(response => response.data)
            .catch((error) => console.log('[api.categorias.index] Error\n', error));
    }
    indicadores = async (_id) => {
        return await Api.get(`categorias/${_id}/indicadores`).then(response => response.data)
            .catch((error) => console.log('[categoriasAPi.indicadores:] Error\n', error));
    }

    indicadoresComValoresPorAno = async (_categoria_id, _ano) => {
        return await Api.get(`categorias/${_categoria_id}/indicadores/ano/${_ano}`).then(response => response.data)
            .catch((error) => console.log('[categoriasAPi.indicadoresComValoresPorAno:] Error\n', error));
    }

}